import { faClock } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import dayjs from "dayjs";
import React from "react";
import { CalendarEvent } from "../../models/CalendarEvent";

interface DeliveryTimingProps {
    calendarEvent: CalendarEvent;
}

const DeliveryTiming: React.FC<DeliveryTimingProps> = (props) => {
    const daysUntilDelivery = dayjs(props.calendarEvent.startAt).diff(dayjs(), "day");

    const daysUntilDeliveryText = (daysUntilDelivery: number) => {
        switch (daysUntilDelivery) {
            case 0:
                return "Today";
            case 1:
                return "1 Day";
            default:
                return `${daysUntilDelivery} Days`;
        }
    };
    return (
        <section className="mx-4 mt-4">
            <div className="bg-linear-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-xl p-6 border border-gray-700">
                <div className="flex items-center justify-between">
                    <div>
                        <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold mb-2">
                            Delivery Expected {daysUntilDelivery > 0 && "In"}
                        </p>
                        <p className="text-5xl font-black text-white tracking-tight">
                            {daysUntilDeliveryText(daysUntilDelivery)}
                        </p>
                        <p className="text-sm text-gray-400 mt-2">
                            {dayjs(props.calendarEvent.startAt).format("MMMM D, YYYY")} •{" "}
                            {dayjs(props.calendarEvent.startAt).format("h:mm A")} -{" "}
                            {dayjs(props.calendarEvent.endAt).format("h:mm A")}
                        </p>
                    </div>
                    <div className="bg-plot-orange/20 p-4 rounded-2xl">
                        <FontAwesomeIcon icon={faClock} className="text-plot-orange" size="3x" />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DeliveryTiming;
